import React from 'react';
import { DollarSign } from 'lucide-react';
import { Button } from '../../components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';

const AdminExpensesTab = ({
  expenses,
  totalExpenses,
  newExpense,
  setNewExpense,
  addExpense,
}) => {
  return (
    <div data-testid="admin-expenses-tab">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.5rem' }}>
        <h2 style={{ fontSize: '1.5rem', fontWeight: '700' }}>Business Expenses</h2>
        <div style={{ fontSize: '0.875rem', color: '#6b7280' }}>
          Total: ${totalExpenses.toFixed(2)}
        </div>
      </div>

      {/* Add Expense Form */}
      <Card style={{ marginBottom: '1.5rem', border: '2px solid #10b981' }}>
        <CardHeader style={{ backgroundColor: '#f0fdf4' }}>
          <CardTitle style={{ fontSize: '1.1rem', color: '#065f46' }}>Add New Expense</CardTitle>
        </CardHeader>
        <CardContent style={{ padding: '1rem' }}>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))', gap: '0.75rem' }}>
            <div>
              <label style={{ display: 'block', fontSize: '0.875rem', fontWeight: '600', marginBottom: '0.5rem', color: '#374151' }}>
                Date *
              </label>
              <input
                type="date"
                value={newExpense.date}
                onChange={(e) => setNewExpense({ ...newExpense, date: e.target.value })}
                data-testid="expense-date-input"
                style={{
                  width: '100%',
                  padding: '0.5rem',
                  border: '1px solid #d1d5db',
                  borderRadius: '6px',
                  fontSize: '0.875rem',
                }}
              />
            </div>
            <div>
              <label style={{ display: 'block', fontSize: '0.875rem', fontWeight: '600', marginBottom: '0.5rem', color: '#374151' }}>
                Type *
              </label>
              <select
                value={newExpense.type}
                onChange={(e) => setNewExpense({ ...newExpense, type: e.target.value })}
                data-testid="expense-type-select"
                style={{
                  width: '100%',
                  padding: '0.5rem',
                  border: '1px solid #d1d5db',
                  borderRadius: '6px',
                  fontSize: '0.875rem',
                }}
              >
                <option value="">Select type...</option>
                <option value="gas">Gas</option>
                <option value="toll">Toll</option>
                <option value="mileage">Mileage</option>
                <option value="parking">Parking</option>
                <option value="other">Other</option>
              </select>
            </div>
            <div>
              <label style={{ display: 'block', fontSize: '0.875rem', fontWeight: '600', marginBottom: '0.5rem', color: '#374151' }}>
                Amount ($) *
              </label>
              <input
                type="number"
                step="0.01"
                value={newExpense.amount}
                onChange={(e) => setNewExpense({ ...newExpense, amount: e.target.value })}
                data-testid="expense-amount-input"
                style={{
                  width: '100%',
                  padding: '0.5rem',
                  border: '1px solid #d1d5db',
                  borderRadius: '6px',
                  fontSize: '0.875rem',
                }}
                placeholder="0.00"
              />
            </div>
            <div>
              <label style={{ display: 'block', fontSize: '0.875rem', fontWeight: '600', marginBottom: '0.5rem', color: '#374151' }}>
                Mileage (optional)
              </label>
              <input
                type="text"
                value={newExpense.mileage}
                onChange={(e) => setNewExpense({ ...newExpense, mileage: e.target.value })}
                data-testid="expense-mileage-input"
                style={{
                  width: '100%',
                  padding: '0.5rem',
                  border: '1px solid #d1d5db',
                  borderRadius: '6px',
                  fontSize: '0.875rem',
                }}
                placeholder="e.g., 25 miles"
              />
            </div>
          </div>
          <div style={{ marginTop: '1rem' }}>
            <label style={{ display: 'block', fontSize: '0.875rem', fontWeight: '600', marginBottom: '0.5rem', color: '#374151' }}>
              Description
            </label>
            <input
              type="text"
              value={newExpense.description}
              onChange={(e) => setNewExpense({ ...newExpense, description: e.target.value })}
              data-testid="expense-description-input"
              style={{
                width: '100%',
                padding: '0.5rem',
                border: '1px solid #d1d5db',
                borderRadius: '6px',
                fontSize: '0.875rem',
              }}
              placeholder="e.g., Trip to FedEx Scottsdale Quarter"
            />
          </div>
          <div style={{ marginTop: '1rem' }}>
            <Button
              onClick={addExpense}
              data-testid="add-expense-btn"
              style={{
                padding: '0.75rem 1.5rem',
                backgroundColor: '#10b981',
                color: 'white',
                fontSize: '0.875rem',
                fontWeight: '600',
              }}
            >
              <DollarSign size={16} style={{ marginRight: '0.5rem' }} />
              Add Expense
            </Button>
          </div>
        </CardContent>
      </Card>

      {/* Expenses List */}
      <Card>
        <CardContent style={{ padding: '0', overflowX: 'auto' }}>
          <div style={{ minWidth: '650px' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead style={{ backgroundColor: '#f9fafb', borderBottom: '2px solid #e5e7eb' }}>
                <tr>
                  <th style={{ padding: '0.75rem', textAlign: 'left', fontWeight: '600', fontSize: '0.75rem', color: '#374151' }}>
                    Date
                  </th>
                  <th style={{ padding: '0.75rem', textAlign: 'left', fontWeight: '600', fontSize: '0.75rem', color: '#374151' }}>
                    Type
                  </th>
                  <th style={{ padding: '0.75rem', textAlign: 'left', fontWeight: '600', fontSize: '0.75rem', color: '#374151' }}>
                    Description
                  </th>
                  <th style={{ padding: '0.75rem', textAlign: 'center', fontWeight: '600', fontSize: '0.75rem', color: '#374151' }}>
                    Mileage
                  </th>
                  <th style={{ padding: '0.75rem', textAlign: 'right', fontWeight: '600', fontSize: '0.75rem', color: '#374151' }}>
                    Amount
                  </th>
                </tr>
              </thead>
              <tbody>
                {expenses && expenses.map((expense, idx) => (
                  <tr key={expense.id || `expense-${expense.date}-${idx}`} style={{ borderBottom: '1px solid #e5e7eb' }}>
                    <td style={{ padding: '0.75rem', fontSize: '0.75rem', color: '#374151' }}>
                      {expense.date}
                    </td>
                    <td style={{ padding: '0.75rem' }}>
                      <span style={{
                        padding: '0.25rem 0.75rem',
                        borderRadius: '9999px',
                        fontSize: '0.75rem',
                        fontWeight: '600',
                        backgroundColor: '#e0e7ff',
                        color: '#3730a3',
                      }}>
                        {expense.type}
                      </span>
                    </td>
                    <td style={{ padding: '0.75rem', fontSize: '0.75rem', color: '#6b7280' }}>
                      {expense.description || 'N/A'}
                    </td>
                    <td style={{ padding: '0.75rem', textAlign: 'center', fontSize: '0.75rem', color: '#6b7280' }}>
                      {expense.mileage || '-'}
                    </td>
                    <td style={{ padding: '0.75rem', textAlign: 'right', fontWeight: '700', color: '#ef4444', fontSize: '0.875rem' }}>
                      ${parseFloat(expense.amount || 0).toFixed(2)}
                    </td>
                  </tr>
                ))}
                {expenses.length === 0 && (
                  <tr>
                    <td colSpan="5" style={{ padding: '2rem', textAlign: 'center', color: '#9ca3af' }}>
                      No expenses recorded yet
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default AdminExpensesTab;
